// extracted by mini-css-extract-plugin
export default {"TermSearch":"qBeTl5QDyK2hzjLWbmTi","TermSearch_mobile":"r14Pi88fQOljHI9J3GvS","TermSearch_Submit":"Q6w1QnYaGheAeUXtaLQm"};